import { withSvgIcon } from './withSvgIcon';

export const PowerSwitch = withSvgIcon(
  <path
    stroke="currentColor"
    strokeWidth="2"
    d="M12 2.25v8M15.876 5.25a8 8 0 1 1-7.752 0"
  />,
  { viewBox: '0 0 24 25' },
);
